import { useTheme } from '@stores/ThemeContext';
import { useLanguage } from '@utils/hooks/useLanguage';
import { useTranslations } from '../../../../../../translation/TranslationContext';
import ScoreColumn from '@components/StatsConsole/Widgets/H2HWidget/parts/H2H/ScoreColumn/ScoreColumn';
import PreviouseMeetingsLine from './PreviouseMeetingsLine';
import { T } from "@utils/enums";

interface PreviouseMeetingsProps {
    previousMeetings: any;
}
const PreviouseMeetings = ({ previousMeetings }: PreviouseMeetingsProps) => {
    const language = useLanguage();
    const t = useTranslations(language);
    const { theme } = useTheme();


    return (
        <div data-testid="h2h-previous-meetings-container" className='w-full h-[100px] px-[16px] flex flex-col justify-start items-center'>
            <div data-testid="h2h-previous-meetings-title" className='text-[12px] leading-[16px] text-highlight-light dark:text-highlight-dark font-robotoMedium font-medium w-full
            flex justify-center items-center'>{t[`InHouseStats.H2HPreviousMeetings`]}</div>
            <div data-testid="h2h-previous-meetings-score-column-container" className='max-w-[287px] w-full h-[64px] flex flex-row justify-between items-center mt-[8px]'>
                <ScoreColumn 
                    name={previousMeetings?.homeTeam} 
                    status={t[`InHouseStats.H2HWon`]} 
                    games={previousMeetings?.homeWon} 
                    color={theme === T.DARK ? "success090" : "success110"} 
                    team={'home'} 
                />
                <ScoreColumn 
                    status={t[`InHouseStats.H2HDraw`]} 
                    games={previousMeetings?.draw} 
                    color={theme === T.DARK ? "base090" : "base090"} 
                    team={'center'} />
                <ScoreColumn 
                name={previousMeetings?.awayTeam} status={t[`InHouseStats.H2HWon`]} games={previousMeetings?.awayWon} color={theme === T.DARK ? "interactive090" : "attention110"} team={'away'} />
            </div>
            <div data-testid="h2h-previous-meetings-line-container" className='max-w-[287px] w-full mt-[8px] mb-[8px]'>
                <PreviouseMeetingsLine label={previousMeetings?.homeTeam} home={previousMeetings?.homeWon} draw={previousMeetings?.draw} away={previousMeetings?.awayWon}  />
            </div>
        </div>
    )
}

export default PreviouseMeetings;